import styled from 'styled-components';
const SearchGroupStyled = styled.div`
  background-color: #fff;
  border-radius: 12px;
  padding: 24px 32px 32px;
  .search-wrapper {
    display: flex;
    gap: 0 102px;
  }

  .left {
    flex-grow: 1;
    display: flex;
    align-items: center;
  }

  .button-group {
    height: 100%;
    display: flex;
    gap: 16px;
  }
  .first-line {
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    gap: 24px;
    > div {
      flex: 1;
      flex-shrink: 1;
    }
    .single-select {
      width: 212px;
      flex-shrink: 0;
    }
  }
`;
export default SearchGroupStyled;
